module.exports = __webpack_public_path__ + "img/first6.c85e3a69.png";